import React from 'react';
import { Link } from 'react-router-dom';

const ABTestPage = () => {
  return (
    <div data-testid="ab-test-page" className="fixed inset-0 z-[9999] bg-[#0a0a0a] overflow-y-auto">
      <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12">
        <div className="text-center mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">A/B TEST</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4">
            Scegli il look di <span className="text-[#00FF41]">&lt;/AI_covo.tech&gt;</span> <span className="text-zinc-500 text-xs">DIGITAL HUB SOCIALE</span>
          </h1>
          <p className="text-zinc-400 max-w-xl mx-auto text-sm sm:text-base">
            Stesso contenuto, tre esperienze. Clicca per esplorare e poi decidete.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl w-full">
          {/* Version A - Stanford */}
          <Link to="/versione-a" data-testid="ab-link-stanford"
            className="group relative rounded-2xl overflow-hidden border-2 border-transparent hover:border-[#8C1515] transition-all duration-500 cursor-pointer">
            <div className="bg-[#1B1B1B] p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-full bg-[#8C1515] flex items-center justify-center text-white font-black text-lg">A</div>
                <div>
                  <h2 className="text-lg font-bold text-white">Stanford</h2>
                  <p className="text-zinc-500 text-xs">Dark + Elegante</p>
                </div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#8C1515]"></div>
                  <p className="text-zinc-300 text-sm">Rosso Cardinale</p>
                </div>
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#175E54]"></div>
                  <p className="text-zinc-300 text-sm">Source Sans + Serif</p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden border border-white/10">
                <div className="bg-[#2D2B2E] h-6 flex items-center px-2 gap-1">
                  <div className="w-2 h-2 rounded-full bg-[#8C1515]"></div>
                  <div className="w-2 h-2 rounded-full bg-[#175E54]"></div>
                  <div className="w-2 h-2 rounded-full bg-zinc-600"></div>
                </div>
                <div className="bg-[#1B1B1B] p-3">
                  <div className="h-2 w-20 bg-[#8C1515]/30 rounded mb-1.5"></div>
                  <div className="h-4 w-32 bg-white/10 rounded mb-2"></div>
                  <div className="flex gap-1.5">
                    <div className="h-6 w-16 bg-[#8C1515] rounded"></div>
                    <div className="h-6 w-16 bg-white/10 rounded border border-white/20"></div>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <span className="inline-flex items-center gap-2 text-[#8C1515] font-bold text-xs uppercase tracking-wider group-hover:gap-3 transition-all">
                  Esplora A
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                </span>
              </div>
            </div>
          </Link>

          {/* Version C - MASHUP (center, featured) */}
          <Link to="/versione-c" data-testid="ab-link-mashup"
            className="group relative rounded-2xl overflow-hidden border-2 border-transparent hover:border-[#C4532D] transition-all duration-500 cursor-pointer ring-2 ring-[#C4532D]/30">
            <div className="absolute top-3 right-3 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider"
              style={{ background: '#C4532D', color: '#fff' }}>Mashup</div>
            <div className="p-6 sm:p-8" style={{ background: '#FAF9F6' }}>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center font-black text-lg text-white" style={{ background: '#1B2A4A' }}>C</div>
                <div>
                  <h2 className="text-lg font-bold" style={{ color: '#1B2A4A' }}>Mashup</h2>
                  <p className="text-xs" style={{ color: '#8A96A5' }}>Stanford + Governo</p>
                </div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ background: '#C4532D' }}></div>
                  <p className="text-sm" style={{ color: '#5A6B80' }}>Terracotta + Navy</p>
                </div>
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ background: '#1B2A4A' }}></div>
                  <p className="text-sm" style={{ color: '#5A6B80' }}>Serif + Titillium</p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden border" style={{ borderColor: '#E2DED6' }}>
                <div className="h-6 flex items-center px-2 gap-1" style={{ background: '#C4532D' }}>
                  <div className="w-2 h-2 rounded-full bg-white/40"></div>
                  <div className="w-2 h-2 rounded-full bg-white/30"></div>
                  <div className="w-2 h-2 rounded-full bg-white/20"></div>
                </div>
                <div className="p-3" style={{ background: '#FAF9F6' }}>
                  <div className="h-2 w-20 rounded mb-1.5" style={{ background: '#C4532D30' }}></div>
                  <div className="h-4 w-32 rounded mb-2" style={{ background: '#1B2A4A15' }}></div>
                  <div className="flex gap-1.5">
                    <div className="h-6 w-16 rounded" style={{ background: '#C4532D' }}></div>
                    <div className="h-6 w-16 rounded border" style={{ background: '#FAF9F6', borderColor: '#1B2A4A30' }}></div>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <span className="inline-flex items-center gap-2 font-bold text-xs uppercase tracking-wider group-hover:gap-3 transition-all" style={{ color: '#C4532D' }}>
                  Esplora C
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                </span>
              </div>
            </div>
          </Link>

          {/* Version B - Governo */}
          <Link to="/versione-b" data-testid="ab-link-governo"
            className="group relative rounded-2xl overflow-hidden border-2 border-transparent hover:border-[#0066CC] transition-all duration-500 cursor-pointer">
            <div className="bg-[#F5F7FA] p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-full bg-[#0066CC] flex items-center justify-center text-white font-black text-lg">B</div>
                <div>
                  <h2 className="text-lg font-bold text-[#17324D]">Istituzionale</h2>
                  <p className="text-[#5A768A] text-xs">Bianco + Azzurro</p>
                </div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#0066CC]"></div>
                  <p className="text-[#17324D] text-sm">Azzurro Governo</p>
                </div>
                <div className="flex gap-2 items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#17324D]"></div>
                  <p className="text-[#17324D] text-sm">Titillium Web</p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden border border-[#D9DADB]">
                <div className="bg-[#0066CC] h-6 flex items-center px-2 gap-1">
                  <div className="w-2 h-2 rounded-full bg-white/40"></div>
                  <div className="w-2 h-2 rounded-full bg-white/30"></div>
                  <div className="w-2 h-2 rounded-full bg-white/20"></div>
                </div>
                <div className="bg-white p-3">
                  <div className="h-2 w-20 bg-[#0066CC]/20 rounded mb-1.5"></div>
                  <div className="h-4 w-32 bg-[#17324D]/10 rounded mb-2"></div>
                  <div className="flex gap-1.5">
                    <div className="h-6 w-16 bg-[#0066CC] rounded"></div>
                    <div className="h-6 w-16 bg-[#F5F7FA] rounded border border-[#0066CC]/30"></div>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <span className="inline-flex items-center gap-2 text-[#0066CC] font-bold text-xs uppercase tracking-wider group-hover:gap-3 transition-all">
                  Esplora B
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                </span>
              </div>
            </div>
          </Link>
        </div>

        <div className="mt-10 text-center">
          <Link to="/" className="text-zinc-600 hover:text-white text-sm transition-colors" data-testid="ab-back-home">
            Torna alla versione attuale
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ABTestPage;
